import { ICONS, industryByKey } from "../lib/constants";

export default function IndustryBadge({ industryKey, size = "sm" }) {
  const ind = industryByKey(industryKey);
  const Icon = ICONS[ind.icon] || ICONS.puzzle;
  return (
    <span
      data-testid={`industry-badge-${industryKey}`}
      className={`inline-flex items-center gap-1.5 rounded-sm border font-medium ${
        size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"
      }`}
      style={{ backgroundColor: `color-mix(in srgb, ${ind.color} 10%, transparent)`, color: ind.color, borderColor: `color-mix(in srgb, ${ind.color} 25%, transparent)` }}
    >
      <Icon size={size === "sm" ? 11 : 14} weight="fill" />
      {ind.name}
    </span>
  );
}
